import { render, staticRenderFns } from "./AvaliationItemResultsList.vue?vue&type=template&id=1fbc3226"
import script from "./AvaliationItemResultsList.vue?vue&type=script&lang=js"
export * from "./AvaliationItemResultsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports